import madeStore from "components/jiffy/vue-product-details-print/store/store";
import { MODES } from "components/jiffy/vue-product-details-print/misc/constants";
import ScrollToElement from "common/utils/ui/scroll-to-element";

import "./jiffy-made-upsell-card.scss";

const $getJiffyMadeUpsellCard = () => document.querySelector(".js-jiffy-made-upsell-card");

const init = () => {
  const $card = $getJiffyMadeUpsellCard();
  if (!$card) return;

  const { hasJiffyMade } = $card.dataset;

  $card.addEventListener("click", evt => {
    if (!hasJiffyMade) {
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();
    madeStore.commit("app/setMode", MODES.MADE);
    ScrollToElement.scrollIntoViewBySelector(".js-pdp-experience-switcher");
  });
};

export default init;
